import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationModalService } from '@usheru-hff/shared/utils-authentication';
import { AuthService } from '@usheru-hff/authentication/domain';

@Injectable({
  providedIn: 'root'
})
export class RegisterParameterGuard implements CanActivate {
  constructor(
    private router: Router,
    private uiAuthService: AuthenticationModalService,
    private authService: AuthService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const requiredParam = route.queryParams['register'];

    if (requiredParam === 'true' && !this.uiAuthService.hasHandledRegister) {
      this.uiAuthService.hasHandledRegister = true;
      if (!this.authService.isLoggedIn()) {
        this.uiAuthService.openForm('register');
      }
      return true;
    }
    return true;
  }
}
